import AsyncStorage from '@react-native-async-storage/async-storage';
let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  StatusBar,
  TextInput,
  Alert,
  Dimensions,
} from 'react-native';
import { Ionicons, MaterialCommunityIcons, FontAwesome5 } from '@expo/vector-icons';
import { apiFetch } from '../../utils/apiClient';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';
import { COMMERCE_DISABLED, CommerceUnavailable } from '../../utils/iosCommerce';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
const { width } = Dimensions.get('window');

const CourseEnrollmentScreen = ({ navigation, route }) => {
  if (COMMERCE_DISABLED) return <CommerceUnavailable navigation={navigation} />;
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_courseenrollmentscreen`;
    apiFetch('/api/data/applications?sort=created_at&order=desc&limit=10').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  const { course, courseId } = route.params;
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    education: '',
    experience: '',
    motivation: '',
  });

  // Sample course data with fallbacks
  const courseData = {
    id: course?.id || courseId || '1',
    title: course?.title || 'Engineering Course',
    instructor: course?.instructor || 'Dr. Engineering Professor',
    price: course?.price || 79,
    isFree: course?.isFree || false,
    duration: course?.duration || '12 hours',
    level: course?.level || 'Intermediate',
    color: course?.color || '#0e4e96',
    icon: course?.icon || 'book-open-variant',
    rating: course?.rating || 4.8,
    students: course?.students || 1250,
  };

  const steps = [
    { id: 1, title: 'Personal Info', icon: 'account' },
    { id: 2, title: 'Background', icon: 'school' },
    { id: 3, title: 'Confirmation', icon: 'check-circle' },
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const validateStep = (step) => {
    switch (step) {
      case 1:
        return formData.firstName && formData.lastName && formData.email && formData.phone;
      case 2:
        return formData.education && formData.experience && formData.motivation;
      default:
        return true;
    }
  };

  const handleNext = () => {
    if (validateStep(currentStep)) {
      if (currentStep < 3) {
        setCurrentStep(currentStep + 1);
      } else {
        handleEnrollment();
      }
    } else {
      Alert.alert('Incomplete Information', 'Please fill in all required fields.');
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleEnrollment = () => {
    // If the course is free, no payment needed — just enroll and proceed.
    if (courseData.isFree || !courseData.price || Number(courseData.price) <= 0) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        Alert.alert(
          'Enrollment Successful!',
          `You have successfully enrolled in "${courseData.title}". Welcome to the course!`,
          [
            {
              text: 'Start Learning',
              onPress: () => navigation.replace('CourseLearning', { course: courseData })
            }
          ]
        );
      }, 800);
      return;
    }

    // Paid course — route through the real Stripe payment flow.
    // (Previous implementation was a 2-second setTimeout fake — no charge.)
    const scenario = {
      id:            `course_${courseData.id}`,
      type:          'course',
      category:      'learning',
      name:          courseData.title,
      description:   `Enrollment in ${courseData.title}`,
      amountInPence: Math.round(Number(courseData.price) * 100),
      currency:      'GBP',
      metadata: {
        course_id:      courseData.id,
        course_title:   courseData.title,
        instructor:     courseData.instructor,
        user_id:        profileCtx?.userId || null,
        // Pass enrollment-form info so the backend can attach it after payment
        enrollment_first_name: formData.firstName,
        enrollment_last_name:  formData.lastName,
        enrollment_email:      formData.email,
        enrollment_phone:      formData.phone,
        enrollment_education:  formData.education,
        enrollment_experience: formData.experience,
        enrollment_motivation: formData.motivation,
      },
      successRoute:  'CourseLearning',
      successParams: { course: courseData },
    };
    navigation.navigate('PaymentScreen', { scenario });
  };

  const renderStepIndicator = () => (
    <View style={styles.stepIndicator}>
      {steps.map((step, index) => (
        <View key={step.id} style={styles.stepItem}>
          <View style={[
            styles.stepCircle,
            currentStep >= step.id && styles.activeStepCircle,
            currentStep > step.id && styles.completedStepCircle
          ]}>
            {currentStep > step.id ? (
              <MaterialCommunityIcons name="check" size={16} color="#ffffff" />
            ) : (
              <MaterialCommunityIcons 
                name={step.icon} 
                size={16} 
                color={currentStep >= step.id ? "#ffffff" : "#64748B"} 
              />
            )}
          </View>
          <Text style={[
            styles.stepTitle,
            currentStep >= step.id && styles.activeStepTitle
          ]}>
            {step.title}
          </Text>
          {index < steps.length - 1 && (
            <View style={[
              styles.stepConnector,
              currentStep > step.id && styles.activeStepConnector
            ]} />
          )}
        </View>
      ))}
    </View>
  );

  const renderPersonalInfo = () => (
    <View style={styles.stepContent}>
      <Text style={styles.stepHeader}>Personal Information</Text>
      <Text style={styles.stepDescription}>
        Please provide your basic information to enroll in the course.
      </Text>

      <View style={styles.inputRow}>
        <View style={styles.inputHalf}>
          <Text style={styles.inputLabel}>First Name *</Text>
          <TextInput
            style={styles.textInput}
            value={formData.firstName}
            onChangeText={(value) => handleInputChange('firstName', value)}
            placeholder="Enter first name"
            placeholderTextColor="#94A3B8"
          />
        </View>
        <View style={styles.inputHalf}>
          <Text style={styles.inputLabel}>Last Name *</Text>
          <TextInput
            style={styles.textInput}
            value={formData.lastName}
            onChangeText={(value) => handleInputChange('lastName', value)}
            placeholder="Enter last name"
            placeholderTextColor="#94A3B8"
          />
        </View>
      </View>

      <Text style={styles.inputLabel}>Email Address *</Text>
      <TextInput
        style={styles.textInput}
        value={formData.email}
        onChangeText={(value) => handleInputChange('email', value)}
        placeholder="Enter email address"
        placeholderTextColor="#94A3B8"
        keyboardType="email-address"
        autoCapitalize="none"
      />

      <Text style={styles.inputLabel}>Phone Number *</Text>
      <TextInput
        style={styles.textInput}
        value={formData.phone}
        onChangeText={(value) => handleInputChange('phone', value)}
        placeholder="Enter phone number"
        placeholderTextColor="#94A3B8"
        keyboardType="phone-pad"
      />
    </View>
  );

  const renderBackground = () => (
    <View style={styles.stepContent}>
      <Text style={styles.stepHeader}>Educational Background</Text>
      <Text style={styles.stepDescription}>
        Help us understand your background to provide the best learning experience.
      </Text>

      <Text style={styles.inputLabel}>Education Level *</Text>
      <TextInput
        style={styles.textInput}
        value={formData.education}
        onChangeText={(value) => handleInputChange('education', value)}
        placeholder="e.g., Bachelor's in Engineering"
        placeholderTextColor="#94A3B8"
      />

      <Text style={styles.inputLabel}>Work Experience *</Text>
      <TextInput
        style={styles.textInput}
        value={formData.experience}
        onChangeText={(value) => handleInputChange('experience', value)}
        placeholder="e.g., 2 years in civil engineering"
        placeholderTextColor="#94A3B8"
      />

      <Text style={styles.inputLabel}>Why do you want to take this course? *</Text>
      <TextInput
        style={[styles.textInput, styles.textArea]}
        value={formData.motivation}
        onChangeText={(value) => handleInputChange('motivation', value)}
        placeholder="Tell us about your learning goals..."
        placeholderTextColor="#94A3B8"
        multiline
        numberOfLines={4}
        textAlignVertical="top"
      />
    </View>
  );

  const renderConfirmation = () => (
    <View style={styles.stepContent}>
      <Text style={styles.stepHeader}>Enrollment Confirmation</Text>
      <Text style={styles.stepDescription}>
        Please review your information before completing enrollment.
      </Text>

      <View style={styles.summaryCard}>
        <View style={styles.summaryHeader}>
          <View style={[styles.courseIcon, { backgroundColor: courseData.color }]}>
            <MaterialCommunityIcons name={courseData.icon} size={24} color="#ffffff" />
          </View>
          <View style={styles.courseInfo}>
            <Text style={styles.courseTitle}>{courseData.title}</Text>
            <Text style={styles.courseInstructor}>by {courseData.instructor}</Text>
          </View>
        </View>

        <View style={styles.courseDetails}>
          <View style={styles.detailItem}>
            <MaterialCommunityIcons name="clock-outline" size={16} color="#64748B" />
            <Text style={styles.detailText}>{courseData.duration}</Text>
          </View>
          <View style={styles.detailItem}>
            <MaterialCommunityIcons name="signal" size={16} color="#64748B" />
            <Text style={styles.detailText}>{courseData.level}</Text>
          </View>
          <View style={styles.detailItem}>
            <FontAwesome5 name="star" size={14} color="#fdb913" />
            <Text style={styles.detailText}>{courseData.rating} ({courseData.students.toLocaleString()})</Text>
          </View>
        </View>

        <View style={styles.priceSection}>
          <Text style={styles.priceLabel}>Course Price</Text>
          <Text style={styles.priceText}>
            {courseData.isFree ? 'Free' : `£${courseData.price}`}
          </Text>
        </View>
      </View>

      <View style={styles.personalSummary}>
        <Text style={styles.summaryTitle}>Your Information</Text>
        <View style={styles.summaryRow}>
          <Text style={styles.summaryLabel}>Name:</Text>
          <Text style={styles.summaryValue}>{formData.firstName} {formData.lastName}</Text>
        </View>
        <View style={styles.summaryRow}>
          <Text style={styles.summaryLabel}>Email:</Text>
          <Text style={styles.summaryValue}>{formData.email}</Text>
        </View>
        <View style={styles.summaryRow}>
          <Text style={styles.summaryLabel}>Education:</Text>
          <Text style={styles.summaryValue}>{formData.education}</Text>
        </View>
      </View>
    </View>
  );

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return renderPersonalInfo();
      case 2:
        return renderBackground();
      case 3:
        return renderConfirmation();
      default:
        return null;
    }
  };

  return (
    <SafeAreaView style={styles.safeArea}>
      <StatusBar barStyle="dark-content" backgroundColor="#f0f4f8" />
      
      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity
          onPress={() => navigation.goBack()}
          style={styles.backButton}
        >
          <Ionicons name="arrow-back" size={24} color="#0e4e96" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Course Enrollment</Text>
        <View style={styles.placeholder} />
      </View>

      <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
        {/* Step Indicator */}
        {renderStepIndicator()}

        {/* Step Content */}
        {renderStepContent()}
      </ScrollView>

      {/* Navigation Buttons */}
      <View style={styles.navigationButtons}>
        {currentStep > 1 && (
          <TouchableOpacity style={styles.previousButton} onPress={handlePrevious}>
            <MaterialCommunityIcons name="chevron-left" size={20} color="#0e4e96" />
            <Text style={styles.previousButtonText}>Previous</Text>
          </TouchableOpacity>
        )}
        
        <TouchableOpacity 
          style={[styles.nextButton, loading && styles.disabledButton]}
          onPress={handleNext}
          disabled={loading}
        >
          {loading ? (
            <Text style={styles.nextButtonText}>Processing...</Text>
          ) : (
            <>
              <Text style={styles.nextButtonText}>
                {currentStep === 3 ? 'Complete Enrollment' : 'Next'}
              </Text>
              {currentStep < 3 && (
                <MaterialCommunityIcons name="chevron-right" size={20} color="#ffffff" />
              )}
            </>
          )}
        </TouchableOpacity>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#f0f4f8',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 15,
    paddingVertical: 12,
    backgroundColor: '#fff',
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
  },
  backButton: {
    padding: 5,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#0e4e96',
  },
  placeholder: {
    width: 34,
  },
  container: {
    flex: 1,
    padding: 15,
  },
  stepIndicator: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: 20,
    marginBottom: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.22,
    shadowRadius: 2.22,
    elevation: 3,
  },
  stepItem: {
    alignItems: 'center',
    flex: 1,
    position: 'relative',
  },
  stepCircle: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#e0e0e0',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 8,
  },
  activeStepCircle: {
    backgroundColor: '#0e4e96',
  },
  completedStepCircle: {
    backgroundColor: '#4CAF50',
  },
  stepTitle: {
    fontSize: 12,
    color: '#64748B',
    textAlign: 'center',
  },
  activeStepTitle: {
    color: '#0e4e96',
    fontWeight: 'bold',
  },
  stepConnector: {
    position: 'absolute',
    top: 20,
    left: '75%',
    width: '50%',
    height: 2,
    backgroundColor: '#e0e0e0',
  },
  activeStepConnector: {
    backgroundColor: '#4CAF50',
  },
  stepContent: {
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: 20,
    marginBottom: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.22,
    shadowRadius: 2.22,
    elevation: 3,
  },
  stepHeader: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#0e4e96',
    marginBottom: 8,
  },
  stepDescription: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 20,
    lineHeight: 20,
  },
  inputRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  inputHalf: {
    width: '48%',
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: '500',
    color: '#0e4e96',
    marginBottom: 8,
  },
  textInput: {
    borderWidth: 1,
    borderColor: '#e0e0e0',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 12,
    fontSize: 16,
    color: '#333',
    backgroundColor: '#fff',
    marginBottom: 16,
  },
  textArea: {
    height: 100,
    textAlignVertical: 'top',
  },
  summaryCard: {
    backgroundColor: '#f8fafc',
    borderRadius: 10,
    padding: 16,
    marginBottom: 20,
  },
  summaryHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  courseIcon: {
    width: 50,
    height: 50,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  courseInfo: {
    flex: 1,
  },
  courseTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#0e4e96',
    marginBottom: 4,
  },
  courseInstructor: {
    fontSize: 14,
    color: '#64748B',
  },
  courseDetails: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: 16,
  },
  detailItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  detailText: {
    fontSize: 12,
    color: '#64748B',
    marginLeft: 4,
  },
  priceSection: {
    alignItems: 'center',
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: '#e0e0e0',
  },
  priceLabel: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 4,
  },
  priceText: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#0e4e96',
  },
  personalSummary: {
    backgroundColor: '#f8fafc',
    borderRadius: 10,
    padding: 16,
  },
  summaryTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#0e4e96',
    marginBottom: 12,
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  summaryLabel: {
    fontSize: 14,
    color: '#64748B',
  },
  summaryValue: {
    fontSize: 14,
    color: '#0e4e96',
    fontWeight: '500',
  },
  navigationButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 15,
    paddingVertical: 15,
    backgroundColor: '#fff',
    borderTopWidth: 1,
    borderTopColor: '#e0e0e0',
  },
  previousButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#0e4e96',
    backgroundColor: '#fff',
  },
  previousButtonText: {
    color: '#0e4e96',
    fontSize: 16,
    fontWeight: '500',
    marginLeft: 4,
  },
  nextButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 8,
    backgroundColor: '#0e4e96',
    flex: 1,
    marginLeft: 10,
    justifyContent: 'center',
  },
  disabledButton: {
    backgroundColor: '#94A3B8',
  },
  nextButtonText: {
    color: '#ffffff',
    fontSize: 16,
    fontWeight: '500',
    marginRight: 4,
  },
});

export default CourseEnrollmentScreen;

